export default {"src":"/_next/static/media/cold-plunge.6f67f70a.svg","height":117,"width":117,"blurWidth":0,"blurHeight":0};